import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"400px"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"300px"}
}
const _hoisted_6 = {
  class: "title mc",
  style: {}
}
const _hoisted_7 = {
  key: 0,
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_8 = {
  key: 1,
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" フォーム入力後に、日程調整を行うルールを設定できます。現在、"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "ラジオボタン（単一選択）"),
  /*#__PURE__*/_createTextVNode("か、"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "プルダウン"),
  /*#__PURE__*/_createTextVNode("で作成した質問のみが対象です。 どの選択肢を選んだときに表示するか選択肢を選びましょう。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-warning" }, "※ 質問を変更するとルールがうまく機能しません！必ず質問を作成してから、ルールを設定してください。")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb15" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "w100 fw600 fs13 dgrey lskyblueBg rad8 pad15"
}
const _hoisted_16 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_17 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "変更を破棄", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "ルールを保存", -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_FormFieldContent = _resolveComponent("FormFieldContent")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ScheduleRuleModal",
    "content-class": "rad10 with_white_bg shadowContent modalStandard noscroll"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.room.rule)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "ルールを変更"))
              : (_openBlock(), _createElementBlock("p", _hoisted_8, "ルールを設定")),
            _hoisted_9
          ]),
          (_ctx.Util.isBlank(_ctx.fields))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createTextVNode(" 設定できる質問がみつかりませんでした。"),
                _hoisted_11,
                _createTextVNode(" ラジオボタンか、プルダウンを設定してください。 ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: "fr fs13 skyblue pointer",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetRule && _ctx.resetRule(...args)))
                }, "設定をリセットする"),
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, fieldindex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "w100 mt20",
                    key: `${fieldindex}${_ctx.systemUpdatedAt}`
                  }, [
                    _createVNode(_component_FormFieldContent, {
                      field: field,
                      fieldindex: fieldindex + 2,
                      editable: false,
                      updateFromChild: _ctx.updateFromChild,
                      hideFreeText: true,
                      onBlurField: _ctx.blurField
                    }, null, 8, ["field", "fieldindex", "updateFromChild", "onBlurField"]),
                    _hoisted_14
                  ]))
                }), 128)),
                (_ctx.Util.isPresent(_ctx.ruleText))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.ruleText) + "のときに、日程を提示します。 ", 1))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("section", {
            class: "with_white_bg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelRule && _ctx.cancelRule(...args)))
          }, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("section", {
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveRule && _ctx.saveRule(...args)))
          }, _hoisted_22)
        ])
      ])
    ]),
    _: 1
  }))
}